module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_200000-23c4e6897a704ded50e8e9028c5299d6.png";